import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Product } from "../types/Product";
import {
  API,
  fetcher,
  Pagination,
  PaginationResponse,
} from "@/shared/core-configs";
import qr from "query-string";

export const GET_PRODUCTS_FETCH_KEY = "@CORE_PRODUCTS_GET_PRODUCTS_KEY";

type GetProductsParams = {
  storageId?: string;
  type?: "erp" | "local" | "all";
  searchTerm?: string;
  zoneId?: string;
  withStock?: boolean;
} & Partial<Pagination>;

export const getProducts = async (
  storageId?: string,
  type?: "erp" | "local" | "all",
  page = 1,
  pageSize = 10,
  searchTerm?: string,
  zoneId?: string,
  withStock?: boolean,
) => {
  const params = qr.stringify({
    storageId,
    type,
    page,
    pageSize,
    searchTerm,
    zoneId,
    withStock: withStock || undefined,
  });

  const response = await fetcher.get(`${API.GESLUB_SERVICE}/product?${params}`);
  return response.data;
};

export const useGetProducts = ({
  storageId,
  type,
  page,
  pageSize,
  searchTerm,
  zoneId,
  withStock,
}: GetProductsParams = {}) => {
  const { data, error, isPending, refetch } = useQuery<
    PaginationResponse<Product>,
    Error
  >({
    queryKey: [
      GET_PRODUCTS_FETCH_KEY,
      storageId,
      type,
      page,
      pageSize,
      searchTerm,
      zoneId,
      withStock,
    ],
    queryFn: () =>
      getProducts(
        storageId,
        type,
        page,
        pageSize,
        searchTerm,
        zoneId,
        withStock,
      ),
    placeholderData: keepPreviousData,
  });
  return {
    data: data?.data || [],
    pagination: data?.pagination,
    error,
    isPending,
    refetch,
  };
};
